(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-visual-filter"] && !Shopify.designMode) return;
  try {
    
function handleize(str) {
  // 1. Convert to lowercase
  str = str.toLowerCase();
  // 2. Replace non-alphanumeric characters (excluding hyphens) with hyphens and handle multiple hyphens
  str = str.replace(/[^a-z0-9]+/g, '-');
  // 3. Remove leading and trailing hyphens
  str = str.replace(/^-+|-+$/g, '');
  return str;
}
const blocks = document.querySelectorAll('.filter-block')
blocks.forEach(function(element,index) {
  // Perform actions on each 'element'
  
  element.addEventListener('click',function(e){
    const category_name = element.querySelector('.filter-block__heading').textContent || '';
    var slide_index = 0;
    if( element.closest('.slick-slide') ) {
      switch( element.closest('.slick-slide').getAttribute('data-slick-index') ) {
        case '-1':
        case '4':
        case '9':
          slide_index = 5;
          break;
        case '-2':
        case '3':
        case '8':
          slide_index = 4;
          break;
        case '-3':
        case '2':
        case '7':
          slide_index = 3;
          break;
        case '-4':
        case '1':
        case '6':
          slide_index = 2;
          break;
        case '-5':
        case '0':
        case '5':
          slide_index = 1;
          break;
      }
    }else{
      slide_index = index + 1
    }
    window.dataLayer = window.dataLayer || [];
    let new_data = {
      'event':'carousel_click',
      'element_id':'collection-nav-' + handleize(category_name),
      'carousel_section':category_name,
      'carousel_slug':handleize(category_name),
      'carousel_position':slide_index,
      'section_name':'category_navigation',
      'section_title':'Shop by Category',
      'page_type':'Collection',
      'source_url':window.location.pathname,
      'click_text':category_name
    }
    window.dataLayer.push(new_data);
    // console.log(new_data);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-hide-trynow"] && !Shopify.designMode) return;
  try {
    
// Check if the current URL contains "gift-card"
if (window.location.href.includes("gift-card")) {
    // Add the class to the body
    document.body.classList.add("is-gift-card-page");
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp--countdown"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('load', (event) => {
    const countdown_timer = document.getElementById('countdown-container');


    const mobileQuery = window.matchMedia("(max-width: 1024px)");
    
    const countdown_el = document.getElementById('countdown');
    const countdown_text_el = document.getElementById('countdown-text');


    

    function handleBreakpoints() {
        
        // timer
        const donate_text = document.querySelector(".product-form__donate");
        const countdown_timer_clone = countdown_timer.cloneNode(true);
        countdown_timer_clone.classList.remove('move-countdown');
        const donate_text_parent = donate_text.parentElement;
        
        // info
        const product_info = document.querySelector('.hide-on-old-pdp');
        const countdown_text_clone = countdown_text_el.cloneNode(true);
        const product_info_parent = product_info.parentElement;
        product_info_parent.insertBefore(countdown_text_clone, product_info.nextElementSibling);

        if (mobileQuery.matches) {
        } else {
            // donate_text_parent.insertBefore(countdown_timer_clone, donate_text.nextElementSibling);
        }
        const more_payment = document.querySelector('.more_payment_options');
            more_payment.style.display = 'none';
            donate_text_parent.insertBefore(countdown_timer_clone, more_payment.nextElementSibling);

    }

    // Execute the function initially to set the initial state
    handleBreakpoints();

    // Add listeners for changes in the media queries
    mobileQuery.addListener(handleBreakpoints);

    if( countdown_timer.classList.contains('hidden') ) {

    }else{
        

        (function () {
            const second = 1000,
                    minute = second * 60,
                    hour = minute * 60,
                    day = hour * 24;

            let today = new Date(),
                dd = String(today.getDate()).padStart(2, "0"),
                mm = String(today.getMonth() + 1).padStart(2, "0"),
                yyyy = '2026',
                specialDay = countdown_el.getAttribute('datetime');
                let specialDaySplit = specialDay.split('/');
                let specialDayNew = specialDaySplit[2] + '-' + specialDaySplit[0] + '-' + specialDaySplit[1] +'T08:00:00Z'
            
            today = mm + "/" + dd + "/" + yyyy;
            //end

            const countDown = new Date(specialDayNew).getTime(),
                x = setInterval(function() {
                  let countdown_text = document.getElementById('countdown-text');
                  let countdown_container = document.getElementById('countdown-container');
                  let black_color_input = document.getElementById('Black');
                  let atc_button = document.querySelector('.product-form__atc .button--primary');

                  if( black_color_input && black_color_input && black_color_input.checked ) {
                    countdown_text.style.display = 'block';
                    countdown_container.style.display = 'block';

                    if( atc_button && !atc_button.disabled && document.querySelector('input[name="option1"]:checked') ){
                      atc_button.querySelector('.button__content').querySelector('span').innerText = 'Preorder'
                    }else{
                      atc_button.querySelector('.button__content').querySelector('span').innerText = atc_button.dataset.label ? atc_button.dataset.label : 'Select a Size';
                    }

                  }else{
                    
                    countdown_text.style.display = 'none';
                    countdown_container.style.display = 'none';
                    
                    if( atc_button && !atc_button.disabled && document.querySelector('input[name="option1"]:checked') ){
                      atc_button.querySelector('.button__content').querySelector('span').innerText = 'Add to Cart'
                    }else{
                      atc_button.querySelector('.button__content').querySelector('span').innerText = atc_button.dataset.label ? atc_button.dataset.label : 'Select a Size';
                    }

                  }

                    const now = new Date().getTime(),
                        distance = countDown - now;

                    if( document.getElementById("days") ){
                        document.getElementById("days").innerText = Math.floor(distance / (day))
                    }
                    if( document.getElementById("hours") ){
                        document.getElementById("hours").innerText = Math.floor((distance % (day)) / (hour))
                    }
                    if( document.getElementById("minutes") ){
                        document.getElementById("minutes").innerText = Math.floor((distance % (hour)) / (minute))
                    }
                    if( document.getElementById("seconds") ){
                        document.getElementById("seconds").innerText = Math.floor((distance % (minute)) / second)
                    }

                    //do something later when date is reached
                    if (distance < 0) {
                        document.getElementById("countdown").style.display = "none";
                        clearInterval(x);
                    }
                    //seconds
                }, 0)
            }());
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    function accordionsMoveLocally() {
        // move Locally
          const locallyButton = document.querySelector('.lcly-container');
          const newLocalContainer = document.getElementById('local-box');
  
          if (locallyButton) {
            newLocalContainer.appendChild(locallyButton);
          }
        }
    const openDetailsIfAnchorHidden = (evt) => {
        const target = evt.currentTarget.getAttribute("href"); // "#anchored"
        const elTarget = document.querySelector(target);

        if (!elTarget) return; // No such element in DOM. Do nothing
        // if (elTarget.offsetHeight > 0 || elTarget.getClientRects().length) return; // Already visible

        // Open all <details> ancestors
        let elDetails = elTarget.closest("details");
        while (elDetails) {
            if (elDetails.matches("details")) elDetails.open = true;
            elDetails = elDetails.parentElement;
        }
    }
    
    window.addEventListener('load', function() {
        document.querySelectorAll("[href^='#']").forEach((el) => {
            el.addEventListener("click", openDetailsIfAnchorHidden);
        });
        const el = document.querySelector(".product-form__atc")
        const rect = el.getBoundingClientRect();
        const topFromViewport = rect.top;
        const topFromDocument = rect.top + window.scrollY; // For position relative to the document

        let more_payment_options = document.querySelector('.more_payment_options');
        more_payment_options.addEventListener('click',function() {
            let dialog_layer = document.getElementById('dialog_layer');
            let dialog1 = document.getElementById('dialog1');
            dialog_layer.classList.remove('hidden');
            dialog1.classList.remove('hidden');
        });
        setTimeout(function(){
            accordionsMoveLocally()
        },1000);
        // FINAL SALE text
        if( document.querySelector('.product-info__description.description-short.hide-on-old-pdp') && document.querySelector('.product-info__description.description-short.hide-on-old-pdp').textContent.includes('FINAL SALE') ){
            document.querySelector('.product-info__description.description-short.hide-on-old-pdp').innerHTML = document.querySelector('.product-info__description.description-short.hide-on-old-pdp').innerHTML.replace('FINAL SALE.','<strong style="font-weight:800">FINAL SALE</strong><br/>')
        }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-featured-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Create a 'resize' event, since we will be tricking the carousel into thinking the user has re-sized the page, since that triggers a reinit
  const resizeEvent = new Event('resize');
  let tabbedCollectionButtons = document.querySelectorAll('.tabbed-collection__btn');
  tabbedCollectionButtons.forEach( btn => {
      btn.addEventListener('click', () => {
        // Dispatch the event on the window object each time a tab is clicked, forcing a reinit of the carousel.
        window.dispatchEvent(resizeEvent);
      })
  });
});

  } catch(e) { console.error(e); }
})();
})();
